import { useState, useEffect } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Buildings, Users, Lifebuoy, Lightbulb, Package, CurrencyDollar } from "phosphor-react";
import { formatCurrency } from "../../utils/formatters";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await fetch(`${API}/admin/dashboard`, { credentials: "include" });
      if (response.ok) {
        setData(await response.json());
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse space-y-6"><div className="h-32 bg-zinc-800 rounded-sm" /></div>;
  }

  const stats = [
    { label: "Total Tenants", value: data?.total_tenants || 0, icon: Buildings, color: "text-blue-400" },
    { label: "Active Tenants", value: data?.active_tenants || 0, icon: Buildings, color: "text-emerald-400" },
    { label: "Total Users", value: data?.total_users || 0, icon: Users, color: "text-purple-400" },
    { label: "Open Tickets", value: data?.open_tickets || 0, icon: Lifebuoy, color: "text-amber-400" },
    { label: "Pending Ideas", value: data?.pending_ideas || 0, icon: Lightbulb, color: "text-pink-400" },
    { label: "Features", value: data?.total_features || 0, icon: Package, color: "text-cyan-400" },
    { label: "MRR", value: formatCurrency(data?.mrr || 0), icon: CurrencyDollar, color: "text-emerald-400" },
    { label: "Subscriptions", value: data?.subscriptions_count || 0, icon: CurrencyDollar, color: "text-amber-400" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl font-bold text-white uppercase">Platform Dashboard</h1>
      
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat, idx) => {
          const Icon = stat.icon;
          return (
            <Card key={idx} className="bg-zinc-900 border-zinc-800">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-zinc-500 uppercase">{stat.label}</p>
                    <p className={`font-heading text-2xl font-bold ${stat.color}`}>{stat.value}</p>
                  </div>
                  <Icon size={32} className={stat.color} />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
